import React, { Component } from 'react';
var ReactSuperSelect = require('react-super-select')

class TransferNumbers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			editing: false,
			filterBy: {}, sortBy: 'DisplayName', sortOrder: 1,
			loading: false
		};
	}

	cancel = () => {
		this.setState({ editing: false, loading: false, Display: false, Description: false, Language: false, phoneNumber: false, active: null })
	}
	editValue = (e) => {
		if (e.target.value.length < 1) {
			this.setState({ phoneNumber: '', error: 'Please enter a transfer number.' });
		} else {
			this.setState({ phoneNumber: e.target.value.replace(/[^0-9]/gm, ''), error: '' });
		}
	}

	editNumber = (num) => e => {
		this.setState({ editing: true, loading: false, Display: num.DisplayName, Description: num.Description, Language: num.Language, phoneNumber: num.Phone_Number, active: num.is_enabled, error: '' })
	}
	confirmEditNumber = () => {
		if (this.state.phoneNumber.length < 10) {
			this.setState({ error: 'Please enter a ten digit transfer number.' });
		} else {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'editTransferNumber', Description: this.state.Description, Language: this.state.Language, phoneNumber: this.state.phoneNumber, active: this.state.active }))
		}
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirmEditNumber();
		}
	}
	toggle = (param) => (e) => {
		var newState = Object.assign({}, this.state)
		newState[param] = this.state[param] ? false : true
		this.setState(newState)
	}
	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel()
		}
	}

	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.DisplayName > b.DisplayName ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			}
		}
	}

	filterFunc(array, filterBy) {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}

	filterByDropdown = (value) => {
		var filterBy = this.state.filterBy
		if (!value) {
			delete filterBy.is_enabled
		} else if (value.id == 1) {
			filterBy.is_enabled = true
		} else if (value.id == 0) {
			filterBy.is_enabled = false
		}
		this.setState({ filterBy: filterBy })

	}

	render() {
		if (this.props.active) {
			var numList = []
			var nums = JSON.parse(JSON.stringify(this.props.data.TransferNumbers));

			//Filtering User List
			console.log('here')
			if (Object.keys(this.state.filterBy).length > 0) {
				nums = this.filterFunc(nums, this.state.filterBy)
			}

			//Sorting filtered User List
			if (this.state.sortBy !== '') {
				nums.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}


			for (var num of nums) {
				numList.push(
					<div className="dataRow" key={num.RecNum} onClick={this.editNumber(num)}>
						<div className="activeBox">
							<div className={num.is_enabled ? "enabled" : "disabled"}></div>
						</div>
						<span style={{ flex: '1 0 300px' }} >{num.DisplayName}</span>
						<span style={{ flex: '0 0 200px', textAlign: 'center' }} >{num.Language}</span>
						<span style={{ flex: '0 0 300px', textAlign: 'center' }} >{num.Phone_Number}</span>
					</div>
				)
			}


			var editNum = ""
			if (this.state.editing) {
				editNum = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>You Are Editing the {this.state.Language} Transfer Number for</div>
							<br />
							<div>{this.state.Display ? this.state.Display : this.state.Description}</div>
							<br />
							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.phoneNumber} onChange={this.editValue} ></input>
								<span className="inputBar"></span><label className="textLabel">Telephone Number</label>
							</div>

							<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
								<div >
									<div>Active</div>
									<div className="activeBox" onClick={this.toggle('active')}>
										<div className={this.state.active ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmEditNumber}>Confirm Transfer Number</div>}
						</div>
					</div>
				)
			}


			return (
				<div width="100%">
					<div className="dataHeaders">
						<span style={{ flex: '0 0 83px', cursor: 'pointer', textAlign: 'center' }} onClick={this.sort("is_enabled")}>Active?</span>
						<span style={{ flex: '1 0 300px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("DisplayName")}>Description</span>
						<span style={{ flex: '0 0 200px', cursor: 'pointer' }} onClick={this.sort("Language")}>Language</span>
						<span style={{ flex: '0 0 300px', cursor: 'pointer' }} onClick={this.sort("Phone_Number")}>Telephone Number</span>
					</div>
					<div className="dataFilters">
						<ReactSuperSelect clearable={false} style={{ flex: '0 0 90px', margin: '0px' }} customClass="r-ss-active" placeholder="   " dataSource={[{ id: 1, name: 'Active' }, { id: 0, name: 'Inactive' }]} onChange={this.filterByDropdown} />
						<input style={{ flex: '1 0 300px' }} type="text" onChange={this.filter("DisplayName")} value={this.state.filterBy.DisplayName} />
						<input style={{ flex: '0 0 200px' }} type="text" onChange={this.filter("Language")} value={this.state.filterBy.Language} />
						<input style={{ flex: '0 0 300px' }} type="text" onChange={this.filter("Phone_Number")} value={this.state.filterBy.Phone_Number} />
					</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{numList}
					</div>

					{editNum}

				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuWorkflow"
const roles = ["View"]
export { TransferNumbers, icon, roles }